<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-05 15:40:59
 * @FilePath: /mrc_ess_web_fronted/src/Layout/404Page.vue
 * @最后编辑: Betway
 * @最后修改时间: 2020-09-05 16:09:15
-->
<template>
  <v-container
    class="max-width d-flex flex-grow-1 ma-0 pa-0 fill-height flex-column justify-center text-center align-center align-self-center"
    :elevation="0"
    style="min-height:500px"
    fluid
  >
    <div>
      <mrc_ess_svgIcon
        style="font-size: 200px;"
        icon-class="Error_404"
      ></mrc_ess_svgIcon>
      <div class="text-h3 mt-n7 grey--text">Page Not Found</div>
      <div class="text-body-m grey--text">
        Click
        <span
          class="primary--text"
          style="text-decoration:underline;cursor:pointer"
          @click="$router.go(-1)"
          >here</span
        >
        to go back to the home page
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  name: 'Page404',
  data() {
    return {}
  },
  methods: {},
}
</script>
<style scoped></style>
